<template>
  <div>
    <v-card :loading="loading" :disabled="loading">
      <v-card-title>
        <span v-if="!passed_list_mode">{{
          $t("number_of_applicants_report.title")
        }}</span>
        <span v-if="passed_list_mode">{{
          $t("applicants_report_list.passed_title")
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="year_id"
          v-bind:label="$t('officer_config.academic_year')"
          v-bind:items="config_years"
          v-bind:item-value="(item) => item.YEAR_ID"
          v-bind:item-text="(item) => item.SEMESTER + ' / ' + item.YEAR"
          outlined
          dense
          @change="update_year(year_id)"
        ></v-autocomplete>

        <v-autocomplete
          v-model="selected_registrar_faculty_id"
          :label="$t('officer_config.faculty')"
          :items="registrar_faculties"
          :item-value="(item) => item.FACULTY_ID"
          :item-text="(item) => objectTranslator(item, 'FACULTY_NAME')"
          outlined
          dense
          @change="update_faculty()"
        ></v-autocomplete>

        <v-autocomplete
          v-if="selected_registrar_faculty_id !== null"
          v-model="selected_round_id"
          :label="$t('program_list.round')"
          :items="available_rounds"
          :item-value="(item) => item.ROUND_ID"
          :item-text="(item) => objectTranslator(item, 'ROUND_NAME')"
          outlined
          dense
          @change="update_round()"
        ></v-autocomplete>

        <!-- ประเภทรับเข้า/แผนการศึกษา/กลุ่มเรียน/สำหรับบัณฑิต -->
        <v-autocomplete
          v-if="level_id === '2' || level_id === '3'"
          v-model="study_admit_type_id"
          :label="$t('officer_config.admit_type')"
          :items="admit_types"
          :item-value="(item) => item.STUDY_ADMIT_TYPE_ID"
          :item-text="(item) => objectTranslator(item, 'STUDY_ADMIT_TYPE_NAME')"
          outlined
          dense
        ></v-autocomplete>
        <v-autocomplete
          v-if="level_id === '2' || level_id === '3'"
          v-model="study_plan_id"
          :label="$t('officer_config.study_plan')"
          :items="programs"
          :item-value="(item) => item.STUDY_PLAN_ID"
          :item-text="(item) => objectTranslator(item, 'STUDY_PLAN_NAME')"
          outlined
          dense
        ></v-autocomplete>
        <v-autocomplete
          v-if="level_id === '2' || level_id === '3'"
          v-model="study_classes_id"
          :label="$t('officer_config.study_classes')"
          :items="classes"
          :item-value="(item) => item.STUDY_CLASSES_ID"
          :item-text="(item) => objectTranslator(item, 'STUDY_CLASSES_NAME')"
          outlined
          dense
        ></v-autocomplete>
        <v-autocomplete
          v-if="level_id === '2' || level_id === '3'"
          v-model="specific_nation_id"
          :label="$t('officer_config.specific_nation')"
          :items="specific_nations"
          :item-value="(item) => item.SPECIFIC_NATION_ID"
          :item-text="(item) => objectTranslator(item, 'SPECIFIC_NATION_NAME')"
          outlined
          dense
        ></v-autocomplete>
        <!-- ----------------------- -->
        <!-- <div v-if="!passed_list_mode"> -->
        <v-checkbox
          v-if="selected_round_id !== null"
          v-model="use_all_project"
          :label="$t('number_of_applicants_report.all_project')"
        ></v-checkbox>

        <v-autocomplete
          v-if="!use_all_project && selected_round_id !== null"
          v-model="selected_project_ids"
          :label="$t('program_list.project')"
          :items="available_projects"
          :item-value="(item) => item.PROJECT_ID"
          :item-text="(item) => objectTranslator(item, 'PROJECT_NAME')"
          outlined
          dense
          chips
          clearable
          deletable-chips
          multiple
        ></v-autocomplete>
        <!-- </div> -->

        <div
          v-if="
            selected_round_id !== null &&
            (use_all_project || selected_project_ids.length > 0)
          "
        >
          <v-divider></v-divider>

          <v-btn
            small
            outlined
            color="deep-purple"
            @click="refresh()"
            class="mt-3"
            >refresh</v-btn
          >
          <div
            v-for="project in use_all_project
              ? all_filtered_curriculums
              : some_filtered_curriculums"
            :key="project.NAME_EN"
          >
            <h2 class="mt-5">{{ objectTranslator(project, "NAME") }}</h2>
            <v-simple-table class="mb-5" dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      {{ $t("number_of_applicants_report.curriculum") }}
                      (ใบสมัคร)
                    </th>
                    <!-- <th class="text-right">
                      {{
                        $t(
                          "number_of_applicants_report.not_complete_information"
                        )
                      }}
                    </th> -->
                    <th class="text-right" v-if="!passed_list_mode">
                      รวมใบสมัคร (ที่มีสถานะจ่ายเงินค่าสมัครแล้วขึ้นไป)
                    </th>
                    <th class="text-right" v-if="!passed_list_mode">
                      {{
                        $t(
                          "number_of_applicants_report.waiting_to_pay_application_fee"
                        )
                      }}
                    </th>
                    <th class="text-right" v-if="!passed_list_mode">
                      รอประกาศผล
                    </th>
                    <th class="text-right" v-if="!passed_list_mode">
                      ผ่าน / รอ Clearing House
                    </th>
                    <th class="text-right" v-if="!passed_list_mode">
                      รอจ่ายค่ายืนยันสิทธิ
                    </th>
                    <th class="text-right" v-if="!passed_list_mode">
                      จ่ายค่ายืนยันสิทธิ์แล้ว
                    </th>
                    <th class="text-right" v-if="passed_list_mode">
                      จำนวนผู้ที่ผ่านการคัดเลือก
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="list in project.table">
                    <tr
                      v-for="item in list"
                      :key="item.MASTER_REG_CURRICULUM_ID + item.BRANCH_ID"
                    >
                      <td class="text-left">
                        {{ objectTranslator(item, "CURRICULUM_NAME") }}
                        <span
                          v-if="item.BRANCH_NAME_TH"
                          class="deep-orange--text"
                        >
                          {{
                            $t("number_of_applicants_by_order_report.branch")
                          }}
                          {{ objectTranslator(item, "BRANCH_NAME") }}</span
                        >
                      </td>
                      <!-- <td class="text-right">{{ item.sum_s1 }}</td> -->

                      <td class="text-right" v-if="!passed_list_mode">
                        <!-- <router-link
                          target="_blank"
                          :to="{
                            name: 'applicants_report_list',
                            query: {
                              faculty_id: selected_registrar_faculty_id,
                              level_id: level_id,
                              year_id: year_id,
                              project_id: project.project_id,
                              round_id: selected_round_id,
                              curriculum_id: item.MASTER_REG_CURRICULUM_ID,
                              admission_curriculum_id: item.CURRICULUM_ID,
                              branch_id: item.BRANCH_ID,

                              study_admit_type_id: study_admit_type_id
                                ? study_admit_type_id
                                : null,
                              study_plan_id: study_plan_id
                                ? study_plan_id
                                : null,
                              study_classes_id: study_classes_id
                                ? study_classes_id
                                : null,
                              specific_nation_id: specific_nation_id
                                ? specific_nation_id
                                : null,

                              status: '0',
                              refused: '0',

                              PROJECT_NAME_TH: project.PROJECT_NAME_TH,
                              PROJECT_NAME_EN: project.PROJECT_NAME_EN,
                              ROUND_NAME_TH: item.ROUND_NAME_TH,
                              ROUND_NAME_EN: item.ROUND_NAME_EN,
                              FACULTY_NAME_TH: item.FACULTY_NAME_TH,
                              FACULTY_NAME_EN: item.FACULTY_NAME_EN,
                              CURRICULUM_NAME_TH: item.CURRICULUM_NAME_TH,
                              CURRICULUM_NAME_EN: item.CURRICULUM_NAME_EN,
                              BRANCH_NAME_TH: item.BRANCH_NAME_TH,
                              BRANCH_NAME_EN: item.BRANCH_NAME_EN,

                              STUDY_ADMIT_TYPE_NAME_EN:
                                item.STUDY_ADMIT_TYPE_NAME_EN,
                              STUDY_ADMIT_TYPE_NAME_TH:
                                item.STUDY_ADMIT_TYPE_NAME_TH,
                              STUDY_PLAN_NAME_EN: item.STUDY_PLAN_NAME_EN,
                              STUDY_PLAN_NAME_TH: item.STUDY_PLAN_NAME_TH,
                              STUDY_CLASSES_NAME_EN: item.STUDY_CLASSES_NAME_EN,
                              STUDY_CLASSES_NAME_TH: item.STUDY_CLASSES_NAME_TH,
                              SPECIFIC_NATION_NAME_EN:
                                item.SPECIFIC_NATION_NAME_EN,
                              SPECIFIC_NATION_NAME_TH:
                                item.SPECIFIC_NATION_NAME_TH,

                              TYPE_DATA_TH:
                                'รวมใบสมัคร (ที่มีสถานะจ่ายเงินค่าสมัครแล้วขึ้นไป)',
                              TYPE_DATA_EN:
                                'รวมใบสมัคร (ที่มีสถานะจ่ายเงินค่าสมัครแล้วขึ้นไป)',
                              COUNT_TOTAL: item.sum_static,
                            },
                          }"
                          > -->
                        {{ item.sum_static }}
                        <!-- </router-link> -->
                      </td>
                      <td class="text-right" v-if="!passed_list_mode">
                        <router-link
                          target="_blank"
                          :to="{
                            name: 'applicants_report_list',
                            query: {
                              faculty_id: selected_registrar_faculty_id,
                              level_id: level_id,
                              year_id: year_id,
                              project_id: project.project_id,
                              round_id: selected_round_id,
                              curriculum_id: item.MASTER_REG_CURRICULUM_ID,
                              admission_curriculum_id: item.CURRICULUM_ID,
                              branch_id: item.BRANCH_ID,

                              study_admit_type_id: study_admit_type_id
                                ? study_admit_type_id
                                : null,
                              study_plan_id: study_plan_id
                                ? study_plan_id
                                : null,
                              study_classes_id: study_classes_id
                                ? study_classes_id
                                : null,
                              specific_nation_id: specific_nation_id
                                ? specific_nation_id
                                : null,

                              status: '2',
                              refused: '0',

                              YEAR: project.YEAR,
                              SEMESTER: project.SEMESTER,
                              PROJECT_NAME_TH: project.PROJECT_NAME_TH,
                              PROJECT_NAME_EN: project.PROJECT_NAME_EN,
                              ROUND_NAME_TH: item.ROUND_NAME_TH,
                              ROUND_NAME_EN: item.ROUND_NAME_EN,
                              FACULTY_NAME_TH: item.FACULTY_NAME_TH,
                              FACULTY_NAME_EN: item.FACULTY_NAME_EN,
                              CURRICULUM_NAME_TH: item.CURRICULUM_NAME_TH,
                              CURRICULUM_NAME_EN: item.CURRICULUM_NAME_EN,
                              BRANCH_NAME_TH: item.BRANCH_NAME_TH,
                              BRANCH_NAME_EN: item.BRANCH_NAME_EN,

                              STUDY_ADMIT_TYPE_NAME_EN:
                                item.STUDY_ADMIT_TYPE_NAME_EN,
                              STUDY_ADMIT_TYPE_NAME_TH:
                                item.STUDY_ADMIT_TYPE_NAME_TH,
                              STUDY_PLAN_NAME_EN: item.STUDY_PLAN_NAME_EN,
                              STUDY_PLAN_NAME_TH: item.STUDY_PLAN_NAME_TH,
                              STUDY_CLASSES_NAME_EN: item.STUDY_CLASSES_NAME_EN,
                              STUDY_CLASSES_NAME_TH: item.STUDY_CLASSES_NAME_TH,
                              SPECIFIC_NATION_NAME_EN:
                                item.SPECIFIC_NATION_NAME_EN,
                              SPECIFIC_NATION_NAME_TH:
                                item.SPECIFIC_NATION_NAME_TH,

                              TYPE_DATA_TH: 'รอจ่ายเงินค่าสมัคร',
                              TYPE_DATA_EN: 'รอจ่ายเงินค่าสมัคร',
                              COUNT_TOTAL: item.sum_s2,
                            },
                          }"
                          >{{ item.sum_s2 }}</router-link
                        >
                      </td>
                      <td class="text-right" v-if="!passed_list_mode">
                        <router-link
                          target="_blank"
                          :to="{
                            name: 'applicants_report_list',
                            query: {
                              faculty_id: selected_registrar_faculty_id,
                              level_id: level_id,
                              year_id: year_id,
                              project_id: project.project_id,
                              round_id: selected_round_id,
                              curriculum_id: item.MASTER_REG_CURRICULUM_ID,
                              admission_curriculum_id: item.CURRICULUM_ID,
                              branch_id: item.BRANCH_ID,

                              study_admit_type_id: study_admit_type_id
                                ? study_admit_type_id
                                : null,
                              study_plan_id: study_plan_id
                                ? study_plan_id
                                : null,
                              study_classes_id: study_classes_id
                                ? study_classes_id
                                : null,
                              specific_nation_id: specific_nation_id
                                ? specific_nation_id
                                : null,

                              status: '3',
                              refused: '0',

                              YEAR: project.YEAR,
                              SEMESTER: project.SEMESTER,
                              PROJECT_NAME_TH: project.PROJECT_NAME_TH,
                              PROJECT_NAME_EN: project.PROJECT_NAME_EN,
                              ROUND_NAME_TH: item.ROUND_NAME_TH,
                              ROUND_NAME_EN: item.ROUND_NAME_EN,
                              FACULTY_NAME_TH: item.FACULTY_NAME_TH,
                              FACULTY_NAME_EN: item.FACULTY_NAME_EN,
                              CURRICULUM_NAME_TH: item.CURRICULUM_NAME_TH,
                              CURRICULUM_NAME_EN: item.CURRICULUM_NAME_EN,
                              BRANCH_NAME_TH: item.BRANCH_NAME_TH,
                              BRANCH_NAME_EN: item.BRANCH_NAME_EN,

                              STUDY_ADMIT_TYPE_NAME_EN:
                                item.STUDY_ADMIT_TYPE_NAME_EN,
                              STUDY_ADMIT_TYPE_NAME_TH:
                                item.STUDY_ADMIT_TYPE_NAME_TH,
                              STUDY_PLAN_NAME_EN: item.STUDY_PLAN_NAME_EN,
                              STUDY_PLAN_NAME_TH: item.STUDY_PLAN_NAME_TH,
                              STUDY_CLASSES_NAME_EN: item.STUDY_CLASSES_NAME_EN,
                              STUDY_CLASSES_NAME_TH: item.STUDY_CLASSES_NAME_TH,
                              SPECIFIC_NATION_NAME_EN:
                                item.SPECIFIC_NATION_NAME_EN,
                              SPECIFIC_NATION_NAME_TH:
                                item.SPECIFIC_NATION_NAME_TH,

                              TYPE_DATA_TH: 'รอประกาศผล',
                              TYPE_DATA_EN: 'รอประกาศผล',
                              COUNT_TOTAL: item.sum_s3,
                            },
                          }"
                          >{{ item.sum_s3 }}</router-link
                        >
                      </td>
                      <td class="text-right" v-if="!passed_list_mode">
                        <router-link
                          target="_blank"
                          :to="{
                            name: 'applicants_report_list',
                            query: {
                              faculty_id: selected_registrar_faculty_id,
                              level_id: level_id,
                              year_id: year_id,
                              project_id: project.project_id,
                              round_id: selected_round_id,
                              curriculum_id: item.MASTER_REG_CURRICULUM_ID,
                              admission_curriculum_id: item.CURRICULUM_ID,
                              branch_id: item.BRANCH_ID,

                              study_admit_type_id: study_admit_type_id
                                ? study_admit_type_id
                                : null,
                              study_plan_id: study_plan_id
                                ? study_plan_id
                                : null,
                              study_classes_id: study_classes_id
                                ? study_classes_id
                                : null,
                              specific_nation_id: specific_nation_id
                                ? specific_nation_id
                                : null,

                              status: '4',
                              refused: '0',

                              YEAR: project.YEAR,
                              SEMESTER: project.SEMESTER,
                              PROJECT_NAME_TH: project.PROJECT_NAME_TH,
                              PROJECT_NAME_EN: project.PROJECT_NAME_EN,
                              ROUND_NAME_TH: item.ROUND_NAME_TH,
                              ROUND_NAME_EN: item.ROUND_NAME_EN,
                              FACULTY_NAME_TH: item.FACULTY_NAME_TH,
                              FACULTY_NAME_EN: item.FACULTY_NAME_EN,
                              CURRICULUM_NAME_TH: item.CURRICULUM_NAME_TH,
                              CURRICULUM_NAME_EN: item.CURRICULUM_NAME_EN,
                              BRANCH_NAME_TH: item.BRANCH_NAME_TH,
                              BRANCH_NAME_EN: item.BRANCH_NAME_EN,

                              STUDY_ADMIT_TYPE_NAME_EN:
                                item.STUDY_ADMIT_TYPE_NAME_EN,
                              STUDY_ADMIT_TYPE_NAME_TH:
                                item.STUDY_ADMIT_TYPE_NAME_TH,
                              STUDY_PLAN_NAME_EN: item.STUDY_PLAN_NAME_EN,
                              STUDY_PLAN_NAME_TH: item.STUDY_PLAN_NAME_TH,
                              STUDY_CLASSES_NAME_EN: item.STUDY_CLASSES_NAME_EN,
                              STUDY_CLASSES_NAME_TH: item.STUDY_CLASSES_NAME_TH,
                              SPECIFIC_NATION_NAME_EN:
                                item.SPECIFIC_NATION_NAME_EN,
                              SPECIFIC_NATION_NAME_TH:
                                item.SPECIFIC_NATION_NAME_TH,

                              TYPE_DATA_TH: 'ผ่าน / รอ Clearing House',
                              TYPE_DATA_EN: 'ผ่าน / รอ Clearing House',
                              COUNT_TOTAL: item.sum_s4,
                            },
                          }"
                          >{{ item.sum_s4 }}</router-link
                        >
                      </td>
                      <td class="text-right" v-if="!passed_list_mode">
                        <router-link
                          target="_blank"
                          :to="{
                            name: 'applicants_report_list',
                            query: {
                              faculty_id: selected_registrar_faculty_id,
                              level_id: level_id,
                              year_id: year_id,
                              project_id: project.project_id,
                              round_id: selected_round_id,
                              curriculum_id: item.MASTER_REG_CURRICULUM_ID,
                              admission_curriculum_id: item.CURRICULUM_ID,
                              branch_id: item.BRANCH_ID,

                              study_admit_type_id: study_admit_type_id
                                ? study_admit_type_id
                                : null,
                              study_plan_id: study_plan_id
                                ? study_plan_id
                                : null,
                              study_classes_id: study_classes_id
                                ? study_classes_id
                                : null,
                              specific_nation_id: specific_nation_id
                                ? specific_nation_id
                                : null,

                              status: '5',
                              refused: '0',

                              YEAR: project.YEAR,
                              SEMESTER: project.SEMESTER,
                              PROJECT_NAME_TH: project.PROJECT_NAME_TH,
                              PROJECT_NAME_EN: project.PROJECT_NAME_EN,
                              ROUND_NAME_TH: item.ROUND_NAME_TH,
                              ROUND_NAME_EN: item.ROUND_NAME_EN,
                              FACULTY_NAME_TH: item.FACULTY_NAME_TH,
                              FACULTY_NAME_EN: item.FACULTY_NAME_EN,
                              CURRICULUM_NAME_TH: item.CURRICULUM_NAME_TH,
                              CURRICULUM_NAME_EN: item.CURRICULUM_NAME_EN,
                              BRANCH_NAME_TH: item.BRANCH_NAME_TH,
                              BRANCH_NAME_EN: item.BRANCH_NAME_EN,

                              STUDY_ADMIT_TYPE_NAME_EN:
                                item.STUDY_ADMIT_TYPE_NAME_EN,
                              STUDY_ADMIT_TYPE_NAME_TH:
                                item.STUDY_ADMIT_TYPE_NAME_TH,
                              STUDY_PLAN_NAME_EN: item.STUDY_PLAN_NAME_EN,
                              STUDY_PLAN_NAME_TH: item.STUDY_PLAN_NAME_TH,
                              STUDY_CLASSES_NAME_EN: item.STUDY_CLASSES_NAME_EN,
                              STUDY_CLASSES_NAME_TH: item.STUDY_CLASSES_NAME_TH,
                              SPECIFIC_NATION_NAME_EN:
                                item.SPECIFIC_NATION_NAME_EN,
                              SPECIFIC_NATION_NAME_TH:
                                item.SPECIFIC_NATION_NAME_TH,

                              TYPE_DATA_TH: 'รอจ่ายค่ายืนยันสิทธิ์',
                              TYPE_DATA_EN: 'รอจ่ายค่ายืนยันสิทธิ์',
                              COUNT_TOTAL: item.sum_s5,
                            },
                          }"
                          >{{ item.sum_s5 }}</router-link
                        >
                      </td>
                      <td class="text-right" v-if="!passed_list_mode">
                        <router-link
                          target="_blank"
                          :to="{
                            name: 'applicants_report_list',
                            query: {
                              faculty_id: selected_registrar_faculty_id,
                              level_id: level_id,
                              year_id: year_id,
                              project_id: project.project_id,
                              round_id: selected_round_id,
                              curriculum_id: item.MASTER_REG_CURRICULUM_ID,
                              admission_curriculum_id: item.CURRICULUM_ID,
                              branch_id: item.BRANCH_ID,

                              study_admit_type_id: study_admit_type_id
                                ? study_admit_type_id
                                : null,
                              study_plan_id: study_plan_id
                                ? study_plan_id
                                : null,
                              study_classes_id: study_classes_id
                                ? study_classes_id
                                : null,
                              specific_nation_id: specific_nation_id
                                ? specific_nation_id
                                : null,

                              status: '6',
                              refused: '0',

                              YEAR: project.YEAR,
                              SEMESTER: project.SEMESTER,
                              PROJECT_NAME_TH: project.PROJECT_NAME_TH,
                              PROJECT_NAME_EN: project.PROJECT_NAME_EN,
                              ROUND_NAME_TH: item.ROUND_NAME_TH,
                              ROUND_NAME_EN: item.ROUND_NAME_EN,
                              FACULTY_NAME_TH: item.FACULTY_NAME_TH,
                              FACULTY_NAME_EN: item.FACULTY_NAME_EN,
                              CURRICULUM_NAME_TH: item.CURRICULUM_NAME_TH,
                              CURRICULUM_NAME_EN: item.CURRICULUM_NAME_EN,
                              BRANCH_NAME_TH: item.BRANCH_NAME_TH,
                              BRANCH_NAME_EN: item.BRANCH_NAME_EN,

                              STUDY_ADMIT_TYPE_NAME_EN:
                                item.STUDY_ADMIT_TYPE_NAME_EN,
                              STUDY_ADMIT_TYPE_NAME_TH:
                                item.STUDY_ADMIT_TYPE_NAME_TH,
                              STUDY_PLAN_NAME_EN: item.STUDY_PLAN_NAME_EN,
                              STUDY_PLAN_NAME_TH: item.STUDY_PLAN_NAME_TH,
                              STUDY_CLASSES_NAME_EN: item.STUDY_CLASSES_NAME_EN,
                              STUDY_CLASSES_NAME_TH: item.STUDY_CLASSES_NAME_TH,
                              SPECIFIC_NATION_NAME_EN:
                                item.SPECIFIC_NATION_NAME_EN,
                              SPECIFIC_NATION_NAME_TH:
                                item.SPECIFIC_NATION_NAME_TH,

                              TYPE_DATA_TH: 'จ่ายค่ายืนยันสิทธิ์แล้ว',
                              TYPE_DATA_EN: 'จ่ายค่ายืนยันสิทธิ์แล้ว',
                              COUNT_TOTAL: item.sum_s6,
                            },
                          }"
                          >{{ item.sum_s6 }}</router-link
                        >
                      </td>

                      <!-- ------- PASSED ------------ -->
                      <td class="text-right" v-if="passed_list_mode">
                        <router-link
                          target="_blank"
                          :to="{
                            name: 'applicants_report_list',
                            query: {
                              faculty_id: selected_registrar_faculty_id,
                              level_id: level_id,
                              year_id: year_id,
                              project_id: project.project_id,
                              round_id: selected_round_id,
                              curriculum_id: item.MASTER_REG_CURRICULUM_ID,
                              admission_curriculum_id:
                                parseInt(level_id) >= 2
                                  ? null
                                  : item.CURRICULUM_ID,
                              branch_id: item.BRANCH_ID,
                              study_admit_type_id: study_admit_type_id
                                ? study_admit_type_id
                                : null,
                              study_plan_id: study_plan_id
                                ? study_plan_id
                                : null,
                              study_classes_id: study_classes_id
                                ? study_classes_id
                                : null,
                              specific_nation_id: specific_nation_id
                                ? specific_nation_id
                                : null,

                              status: '3',

                              YEAR: project.YEAR,
                              SEMESTER: project.SEMESTER,
                              PROJECT_NAME_TH: project.PROJECT_NAME_TH,
                              PROJECT_NAME_EN: project.PROJECT_NAME_EN,
                              ROUND_NAME_TH: item.ROUND_NAME_TH,
                              ROUND_NAME_EN: item.ROUND_NAME_EN,
                              FACULTY_NAME_TH: item.FACULTY_NAME_TH,
                              FACULTY_NAME_EN: item.FACULTY_NAME_EN,
                              CURRICULUM_NAME_TH: item.CURRICULUM_NAME_TH,
                              CURRICULUM_NAME_EN: item.CURRICULUM_NAME_EN,
                              BRANCH_NAME_TH: item.BRANCH_NAME_TH,
                              BRANCH_NAME_EN: item.BRANCH_NAME_EN,

                              STUDY_ADMIT_TYPE_NAME_EN:
                                item.STUDY_ADMIT_TYPE_NAME_EN,
                              STUDY_ADMIT_TYPE_NAME_TH:
                                item.STUDY_ADMIT_TYPE_NAME_TH,
                              STUDY_PLAN_NAME_EN: item.STUDY_PLAN_NAME_EN,
                              STUDY_PLAN_NAME_TH: item.STUDY_PLAN_NAME_TH,
                              STUDY_CLASSES_NAME_EN: item.STUDY_CLASSES_NAME_EN,
                              STUDY_CLASSES_NAME_TH: item.STUDY_CLASSES_NAME_TH,
                              SPECIFIC_NATION_NAME_EN:
                                item.SPECIFIC_NATION_NAME_EN,
                              SPECIFIC_NATION_NAME_TH:
                                item.SPECIFIC_NATION_NAME_TH,

                              TYPE_DATA_TH: 'รอประกาศผล',
                              TYPE_DATA_EN: 'รอประกาศผล',
                              COUNT_TOTAL: item.sum_passed,

                              passed_list_mode: true,
                            },
                          }"
                          >{{ item.sum_passed }}</router-link
                        >
                      </td>
                      <!-- ----------------------------------------- -->
                    </tr>
                  </template>
                  <tr>
                    <td class="text-left font-weight-black indigo--text">
                      {{ $t("number_of_applicants_report.summary") }}
                    </td>
                    <td
                      class="text-right font-weight-black indigo--text"
                      v-if="passed_list_mode"
                    >
                      {{ project.sum_sum_passed }}
                    </td>
                    <td
                      class="text-right font-weight-black indigo--text"
                      v-if="!passed_list_mode"
                    >
                      <!-- <router-link
                        target="_blank"
                        :to="{
                          name: 'applicants_report_list',
                          query: {
                            level_id: level_id,
                            year_id: year_id,
                            project_id: project.project_id,
                            round_id: selected_round_id,
                            faculty_id: selected_registrar_faculty_id,

                            study_admit_type_id: study_admit_type_id
                              ? study_admit_type_id
                              : null,
                            study_plan_id: study_plan_id ? study_plan_id : null,
                            study_classes_id: study_classes_id
                              ? study_classes_id
                              : null,
                            specific_nation_id: specific_nation_id
                              ? specific_nation_id
                              : null,

                            status: '0',
                            refused: '0',

                            PROJECT_NAME_TH: project.PROJECT_NAME_TH,
                            PROJECT_NAME_EN: project.PROJECT_NAME_EN,
                            ROUND_NAME_TH: project.ROUND_NAME_TH,
                            ROUND_NAME_EN: project.ROUND_NAME_EN,
                            FACULTY_NAME_TH: project.FACULTY_NAME_TH,
                            FACULTY_NAME_EN: project.FACULTY_NAME_EN,
                            CURRICULUM_NAME_TH: 'ทั้งหมด',
                            CURRICULUM_NAME_EN: 'All',

                            STUDY_ADMIT_TYPE_NAME_EN: study_admit_type_id
                              ? project.STUDY_ADMIT_TYPE_NAME_EN
                              : '-',
                            STUDY_ADMIT_TYPE_NAME_TH: study_admit_type_id
                              ? project.STUDY_ADMIT_TYPE_NAME_TH
                              : '-',
                            STUDY_PLAN_NAME_EN: study_plan_id
                              ? project.STUDY_PLAN_NAME_EN
                              : '-',
                            STUDY_PLAN_NAME_TH: study_plan_id
                              ? project.STUDY_PLAN_NAME_TH
                              : '-',
                            STUDY_CLASSES_NAME_EN: study_classes_id
                              ? project.STUDY_CLASSES_NAME_EN
                              : '-',
                            STUDY_CLASSES_NAME_TH: study_classes_id
                              ? project.STUDY_CLASSES_NAME_TH
                              : '-',
                            SPECIFIC_NATION_NAME_EN: specific_nation_id
                              ? project.SPECIFIC_NATION_NAME_EN
                              : '-',
                            SPECIFIC_NATION_NAME_TH: specific_nation_id
                              ? project.SPECIFIC_NATION_NAME_TH
                              : '-',

                            TYPE_DATA_TH:
                              'รวมใบสมัคร (ที่มีสถานะจ่ายเงินค่าสมัครแล้วขึ้นไป)',
                            TYPE_DATA_EN:
                              'รวมใบสมัคร (ที่มีสถานะจ่ายเงินค่าสมัครแล้วขึ้นไป)',
                            COUNT_TOTAL: project.sum_sum_static,
                          },
                        }"
                      > -->
                      {{ project.sum_sum_static }}
                      <!-- </router-link> -->
                    </td>
                    <td
                      class="text-right font-weight-black indigo--text"
                      v-if="!passed_list_mode"
                    >
                      <!-- <router-link
                        target="_blank"
                        :to="{
                          name: 'applicants_report_list',
                          query: {
                            level_id: level_id,
                            year_id: year_id,
                            project_id: project.project_id,
                            round_id: selected_round_id,
                            faculty_id: selected_registrar_faculty_id,

                            study_admit_type_id: study_admit_type_id
                              ? study_admit_type_id
                              : null,
                            study_plan_id: study_plan_id ? study_plan_id : null,
                            study_classes_id: study_classes_id
                              ? study_classes_id
                              : null,
                            specific_nation_id: specific_nation_id
                              ? specific_nation_id
                              : null,

                            status: '2',
                            refused: '0',

                            YEAR: project.YEAR,
                            SEMESTER: project.SEMESTER,
                            PROJECT_NAME_TH: project.PROJECT_NAME_TH,
                            PROJECT_NAME_EN: project.PROJECT_NAME_EN,
                            ROUND_NAME_TH: project.ROUND_NAME_TH,
                            ROUND_NAME_EN: project.ROUND_NAME_EN,
                            FACULTY_NAME_TH: project.FACULTY_NAME_TH,
                            FACULTY_NAME_EN: project.FACULTY_NAME_EN,
                            CURRICULUM_NAME_TH: 'ทั้งหมด',
                            CURRICULUM_NAME_EN: 'All',

                            STUDY_ADMIT_TYPE_NAME_EN: study_admit_type_id
                              ? project.STUDY_ADMIT_TYPE_NAME_EN
                              : '-',
                            STUDY_ADMIT_TYPE_NAME_TH: study_admit_type_id
                              ? project.STUDY_ADMIT_TYPE_NAME_TH
                              : '-',
                            STUDY_PLAN_NAME_EN: study_plan_id
                              ? project.STUDY_PLAN_NAME_EN
                              : '-',
                            STUDY_PLAN_NAME_TH: study_plan_id
                              ? project.STUDY_PLAN_NAME_TH
                              : '-',
                            STUDY_CLASSES_NAME_EN: study_classes_id
                              ? project.STUDY_CLASSES_NAME_EN
                              : '-',
                            STUDY_CLASSES_NAME_TH: study_classes_id
                              ? project.STUDY_CLASSES_NAME_TH
                              : '-',
                            SPECIFIC_NATION_NAME_EN: specific_nation_id
                              ? project.SPECIFIC_NATION_NAME_EN
                              : '-',
                            SPECIFIC_NATION_NAME_TH: specific_nation_id
                              ? project.SPECIFIC_NATION_NAME_TH
                              : '-',

                            TYPE_DATA_TH: 'รอจายเงินค่าสมัคร',
                            TYPE_DATA_EN: 'รอจายเงินค่าสมัคร',
                            COUNT_TOTAL: project.sum_sum_s2,
                          },
                        }"
                      >-->
                      {{ project.sum_sum_s2 }}
                      <!-- </router-link>  -->
                    </td>
                    <td
                      class="text-right font-weight-black indigo--text"
                      v-if="!passed_list_mode"
                    >
                      <!-- <router-link
                        target="_blank"
                        :to="{
                          name: 'applicants_report_list',
                          query: {
                            level_id: level_id,
                            year_id: year_id,
                            project_id: project.project_id,
                            round_id: selected_round_id,
                            faculty_id: selected_registrar_faculty_id,

                            study_admit_type_id: study_admit_type_id
                              ? study_admit_type_id
                              : null,
                            study_plan_id: study_plan_id ? study_plan_id : null,
                            study_classes_id: study_classes_id
                              ? study_classes_id
                              : null,
                            specific_nation_id: specific_nation_id
                              ? specific_nation_id
                              : null,

                            status: '3',
                            refused: '0',

                            YEAR: project.YEAR,
                            SEMESTER: project.SEMESTER,
                            PROJECT_NAME_TH: project.PROJECT_NAME_TH,
                            PROJECT_NAME_EN: project.PROJECT_NAME_EN,
                            ROUND_NAME_TH: project.ROUND_NAME_TH,
                            ROUND_NAME_EN: project.ROUND_NAME_EN,
                            FACULTY_NAME_TH: project.FACULTY_NAME_TH,
                            FACULTY_NAME_EN: project.FACULTY_NAME_EN,
                            CURRICULUM_NAME_TH: 'ทั้งหมด',
                            CURRICULUM_NAME_EN: 'All',

                            STUDY_ADMIT_TYPE_NAME_EN: study_admit_type_id
                              ? project.STUDY_ADMIT_TYPE_NAME_EN
                              : '-',
                            STUDY_ADMIT_TYPE_NAME_TH: study_admit_type_id
                              ? project.STUDY_ADMIT_TYPE_NAME_TH
                              : '-',
                            STUDY_PLAN_NAME_EN: study_plan_id
                              ? project.STUDY_PLAN_NAME_EN
                              : '-',
                            STUDY_PLAN_NAME_TH: study_plan_id
                              ? project.STUDY_PLAN_NAME_TH
                              : '-',
                            STUDY_CLASSES_NAME_EN: study_classes_id
                              ? project.STUDY_CLASSES_NAME_EN
                              : '-',
                            STUDY_CLASSES_NAME_TH: study_classes_id
                              ? project.STUDY_CLASSES_NAME_TH
                              : '-',
                            SPECIFIC_NATION_NAME_EN: specific_nation_id
                              ? project.SPECIFIC_NATION_NAME_EN
                              : '-',
                            SPECIFIC_NATION_NAME_TH: specific_nation_id
                              ? project.SPECIFIC_NATION_NAME_TH
                              : '-',

                            TYPE_DATA_TH: 'รอประกาศผล',
                            TYPE_DATA_EN: 'รอประกาศผล',
                            COUNT_TOTAL: project.sum_sum_s3,
                          },
                        }"
                      >-->
                      {{ project.sum_sum_s3 }}
                      <!-- </router-link>  -->
                    </td>
                    <td
                      class="text-right font-weight-black indigo--text"
                      v-if="!passed_list_mode"
                    >
                      <!-- <router-link
                        target="_blank"
                        :to="{
                          name: 'applicants_report_list',
                          query: {
                            level_id: level_id,
                            year_id: year_id,
                            project_id: project.project_id,
                            round_id: selected_round_id,
                            faculty_id: selected_registrar_faculty_id,

                            study_admit_type_id: study_admit_type_id
                              ? study_admit_type_id
                              : null,
                            study_plan_id: study_plan_id ? study_plan_id : null,
                            study_classes_id: study_classes_id
                              ? study_classes_id
                              : null,
                            specific_nation_id: specific_nation_id
                              ? specific_nation_id
                              : null,

                            status: '4',
                            refused: '0',

                            YEAR: project.YEAR,
                            SEMESTER: project.SEMESTER,
                            PROJECT_NAME_TH: project.PROJECT_NAME_TH,
                            PROJECT_NAME_EN: project.PROJECT_NAME_EN,
                            ROUND_NAME_TH: project.ROUND_NAME_TH,
                            ROUND_NAME_EN: project.ROUND_NAME_EN,
                            FACULTY_NAME_TH: project.FACULTY_NAME_TH,
                            FACULTY_NAME_EN: project.FACULTY_NAME_EN,
                            CURRICULUM_NAME_TH: 'ทั้งหมด',
                            CURRICULUM_NAME_EN: 'All',

                            STUDY_ADMIT_TYPE_NAME_EN: study_admit_type_id
                              ? project.STUDY_ADMIT_TYPE_NAME_EN
                              : '-',
                            STUDY_ADMIT_TYPE_NAME_TH: study_admit_type_id
                              ? project.STUDY_ADMIT_TYPE_NAME_TH
                              : '-',
                            STUDY_PLAN_NAME_EN: study_plan_id
                              ? project.STUDY_PLAN_NAME_EN
                              : '-',
                            STUDY_PLAN_NAME_TH: study_plan_id
                              ? project.STUDY_PLAN_NAME_TH
                              : '-',
                            STUDY_CLASSES_NAME_EN: study_classes_id
                              ? project.STUDY_CLASSES_NAME_EN
                              : '-',
                            STUDY_CLASSES_NAME_TH: study_classes_id
                              ? project.STUDY_CLASSES_NAME_TH
                              : '-',
                            SPECIFIC_NATION_NAME_EN: specific_nation_id
                              ? project.SPECIFIC_NATION_NAME_EN
                              : '-',
                            SPECIFIC_NATION_NAME_TH: specific_nation_id
                              ? project.SPECIFIC_NATION_NAME_TH
                              : '-',

                            TYPE_DATA_TH: 'ผ่าน / รอ Clearing House',
                            TYPE_DATA_EN: 'ผ่าน / รอ Clearing House',
                            COUNT_TOTAL: project.sum_sum_s4,
                          },
                        }"
                      >-->
                      {{ project.sum_sum_s4 }}
                      <!-- </router-link>  -->
                    </td>
                    <td
                      class="text-right font-weight-black indigo--text"
                      v-if="!passed_list_mode"
                    >
                      <!-- <router-link
                        target="_blank"
                        :to="{
                          name: 'applicants_report_list',
                          query: {
                            level_id: level_id,
                            year_id: year_id,
                            project_id: project.project_id,
                            round_id: selected_round_id,
                            faculty_id: selected_registrar_faculty_id,

                            study_admit_type_id: study_admit_type_id
                              ? study_admit_type_id
                              : null,
                            study_plan_id: study_plan_id ? study_plan_id : null,
                            study_classes_id: study_classes_id
                              ? study_classes_id
                              : null,
                            specific_nation_id: specific_nation_id
                              ? specific_nation_id
                              : null,

                            status: '5',
                            refused: '0',

                            YEAR: project.YEAR,
                            SEMESTER: project.SEMESTER,
                            PROJECT_NAME_TH: project.PROJECT_NAME_TH,
                            PROJECT_NAME_EN: project.PROJECT_NAME_EN,
                            ROUND_NAME_TH: project.ROUND_NAME_TH,
                            ROUND_NAME_EN: project.ROUND_NAME_EN,
                            FACULTY_NAME_TH: project.FACULTY_NAME_TH,
                            FACULTY_NAME_EN: project.FACULTY_NAME_EN,
                            CURRICULUM_NAME_TH: 'ทั้งหมด',
                            CURRICULUM_NAME_EN: 'All',

                            STUDY_ADMIT_TYPE_NAME_EN: study_admit_type_id
                              ? project.STUDY_ADMIT_TYPE_NAME_EN
                              : '-',
                            STUDY_ADMIT_TYPE_NAME_TH: study_admit_type_id
                              ? project.STUDY_ADMIT_TYPE_NAME_TH
                              : '-',
                            STUDY_PLAN_NAME_EN: study_plan_id
                              ? project.STUDY_PLAN_NAME_EN
                              : '-',
                            STUDY_PLAN_NAME_TH: study_plan_id
                              ? project.STUDY_PLAN_NAME_TH
                              : '-',
                            STUDY_CLASSES_NAME_EN: study_classes_id
                              ? project.STUDY_CLASSES_NAME_EN
                              : '-',
                            STUDY_CLASSES_NAME_TH: study_classes_id
                              ? project.STUDY_CLASSES_NAME_TH
                              : '-',
                            SPECIFIC_NATION_NAME_EN: specific_nation_id
                              ? project.SPECIFIC_NATION_NAME_EN
                              : '-',
                            SPECIFIC_NATION_NAME_TH: specific_nation_id
                              ? project.SPECIFIC_NATION_NAME_TH
                              : '-',

                            TYPE_DATA_TH: 'รอจ่ายค่ายืนยันสิทธิ์',
                            TYPE_DATA_EN: 'รอจ่ายค่ายืนยันสิทธิ์',
                            COUNT_TOTAL: project.sum_sum_s5,
                          },
                        }"
                      >-->
                      {{ project.sum_sum_s5 }}
                      <!-- </router-link>  -->
                    </td>
                    <td
                      class="text-right font-weight-black indigo--text"
                      v-if="!passed_list_mode"
                    >
                      <!-- <router-link
                        target="_blank"
                        :to="{
                          name: 'applicants_report_list',
                          query: {
                            level_id: level_id,
                            year_id: year_id,
                            project_id: project.project_id,
                            round_id: selected_round_id,
                            faculty_id: selected_registrar_faculty_id,

                            study_admit_type_id: study_admit_type_id
                              ? study_admit_type_id
                              : null,
                            study_plan_id: study_plan_id ? study_plan_id : null,
                            study_classes_id: study_classes_id
                              ? study_classes_id
                              : null,
                            specific_nation_id: specific_nation_id
                              ? specific_nation_id
                              : null,

                            status: '6',
                            refused: '0',

                            YEAR: project.YEAR,
                            SEMESTER: project.SEMESTER,
                            PROJECT_NAME_TH: project.PROJECT_NAME_TH,
                            PROJECT_NAME_EN: project.PROJECT_NAME_EN,
                            ROUND_NAME_TH: project.ROUND_NAME_TH,
                            ROUND_NAME_EN: project.ROUND_NAME_EN,
                            FACULTY_NAME_TH: project.FACULTY_NAME_TH,
                            FACULTY_NAME_EN: project.FACULTY_NAME_EN,
                            CURRICULUM_NAME_TH: 'ทั้งหมด',
                            CURRICULUM_NAME_EN: 'All',

                            STUDY_ADMIT_TYPE_NAME_EN: study_admit_type_id
                              ? project.STUDY_ADMIT_TYPE_NAME_EN
                              : '-',
                            STUDY_ADMIT_TYPE_NAME_TH: study_admit_type_id
                              ? project.STUDY_ADMIT_TYPE_NAME_TH
                              : '-',
                            STUDY_PLAN_NAME_EN: study_plan_id
                              ? project.STUDY_PLAN_NAME_EN
                              : '-',
                            STUDY_PLAN_NAME_TH: study_plan_id
                              ? project.STUDY_PLAN_NAME_TH
                              : '-',
                            STUDY_CLASSES_NAME_EN: study_classes_id
                              ? project.STUDY_CLASSES_NAME_EN
                              : '-',
                            STUDY_CLASSES_NAME_TH: study_classes_id
                              ? project.STUDY_CLASSES_NAME_TH
                              : '-',
                            SPECIFIC_NATION_NAME_EN: specific_nation_id
                              ? project.SPECIFIC_NATION_NAME_EN
                              : '-',
                            SPECIFIC_NATION_NAME_TH: specific_nation_id
                              ? project.SPECIFIC_NATION_NAME_TH
                              : '-',

                            TYPE_DATA_TH: 'จ่ายค่ายืนยันสิทธิ์แล้ว',
                            TYPE_DATA_EN: 'จ่ายค่ายืนยันสิทธิ์แล้ว',
                            COUNT_TOTAL: project.sum_sum_s6,
                          },
                        }"
                      >-->
                      {{ project.sum_sum_s6 }}
                      <!-- </router-link>  -->
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!-- <v-divider class="mt-5 mb-5 pt-5 pb-5"></v-divider> -->
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ReportsProvider from "@/services/reports.provider";
import FacultyProvider from "@/services/faculty.provider";
import { objectTranslator } from "@/helper/translator";
import { uniq_by_prop } from "@/helper/array";
import RefProvider from "@/services/ref.provider";
import ConfigProvider from "@/services/config.provider";

const reportsService = new ReportsProvider();
const facultyService = new FacultyProvider();
const refService = new RefProvider();
const configService = new ConfigProvider();

export default {
  name: "NumberOfApplicantsReportDisplay",
  props: {
    level_id: {
      type: String,
      default: "1",
    },
    passed_list_mode: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    use_all_project: true,
    year_id: null,

    selected_registrar_faculty_id: null,
    selected_round_id: null,
    selected_project_ids: [],

    admit_types: [],
    programs: [],
    classes: [],
    specific_nations: [],

    curriculums: [],
    registrar_faculties: [],

    // สำหรับระดับบัณฑิตศึกษา
    study_admit_type_id: null,
    study_plan_id: null,
    study_classes_id: null,
    specific_nation_id: null,
  }),
  computed: {
    available_rounds() {
      const uniqueById = uniq_by_prop("ROUND_ID");
      const ret = uniqueById(
        this.curriculums.filter(
          (item) =>
            item.MASTER_REG_FACULTY_ID === this.selected_registrar_faculty_id
        )
      );
      return ret.map((item) => ({
        ROUND_NAME_TH: item.ROUND_NAME_TH,
        ROUND_NAME_EN: item.ROUND_NAME_EN,
        ROUND_ID: item.ROUND_ID,
      }));
    },
    available_projects() {
      const uniqueById = uniq_by_prop("PROJECT_ID");
      const ret = uniqueById(
        this.curriculums.filter(
          (item) =>
            item.MASTER_REG_FACULTY_ID === this.selected_registrar_faculty_id &&
            item.ROUND_ID === this.selected_round_id
        )
      );
      return ret.map((item) => ({
        PROJECT_NAME_TH: item.PROJECT_NAME_TH,
        PROJECT_NAME_EN: item.PROJECT_NAME_EN,
        PROJECT_ID: item.PROJECT_ID,
      }));
    },
    all_filtered_curriculums() {
      return [this.filtered_curriculums("all")];
    },
    some_filtered_curriculums() {
      return this.selected_project_ids.map((item) =>
        this.filtered_curriculums(item)
      );
    },
    levels() {
      return this.$store.state.ref.levels;
    },
    config_years() {
      return this.$store.state.officerConfig.config_years.filter(
        (item) => item.LEVEL_ID === this.level_id
      );
    },
    user_id() {
      return this.$store.state.auth.user.delegated_officer.user_id;
    },
    privilege() {
      return this.$store.state.auth.user.delegated_officer.privilege;
    },
  },
  methods: {
    objectTranslator,
    update_year(year_id) {
      this.year_id = year_id;
      this.select_year(year_id);
      this.selected_registrar_faculty_id = null;
      this.selected_round_id = null;
      this.selected_project_ids = [];
    },
    update_faculty() {
      this.selected_round_id = null;
      this.selected_project_ids = [];
    },
    update_round() {
      this.selected_project_ids = [];
    },
    get_filter_curriculum_by_project(project_id) {
      let curs = [];
      if (project_id === "all") {
        curs = this.curriculums.filter(
          (item) =>
            item.MASTER_REG_FACULTY_ID === this.selected_registrar_faculty_id &&
            item.ROUND_ID === this.selected_round_id
        );
      } else {
        curs = this.curriculums.filter(
          (item) =>
            item.MASTER_REG_FACULTY_ID === this.selected_registrar_faculty_id &&
            item.ROUND_ID === this.selected_round_id &&
            item.PROJECT_ID === project_id
        );
      }

      if (this.study_admit_type_id) {
        curs = curs.filter(
          (item) => this.study_admit_type_id === item.STUDY_ADMIT_TYPE_ID
        );
      }
      if (this.study_plan_id) {
        curs = curs.filter((item) => this.study_plan_id === item.STUDY_PLAN_ID);
      }
      if (this.study_classes_id) {
        curs = curs.filter(
          (item) => this.study_classes_id === item.STUDY_CLASSES_ID
        );
      }
      if (this.specific_nation_id && this.specific_nation_id !== "0") {
        curs = curs.filter(
          (item) => this.specific_nation_id === item.SPECIFIC_NATION_ID
        );
      }

      const groupedData = Object.values(
        this.groupBy(curs, "MASTER_REG_CURRICULUM_ID")
      );

      let ret = [];
      for (const item of groupedData) {
        const groupedDataByBranch = Object.values(
          this.groupBy(item, "BRANCH_NAME_TH")
        );
        const temp = groupedDataByBranch.map((item) => {
          return {
            CURRICULUM_ID: item[0].CURRICULUM_ID,
            MASTER_REG_CURRICULUM_ID: item[0].MASTER_REG_CURRICULUM_ID,
            CURRICULUM_NAME_TH: item[0].CURRICULUM_NAME_TH,
            CURRICULUM_NAME_EN: item[0].CURRICULUM_NAME_EN,
            YEAR: item[0].YEAR,
            SEMESTER: item[0].SEMESTER,
            PROJECT_NAME_TH: item[0].PROJECT_NAME_TH,
            PROJECT_NAME_EN: item[0].PROJECT_NAME_EN,
            PROJECT_ID: item[0].PROJECT_ID,
            BRANCH_ID: item[0].BRANCH_ID,
            STUDY_PLAN_ID: item[0].STUDY_PLAN_ID,
            STUDY_CLASSES_ID: item[0].STUDY_CLASSES_ID,
            SPECIFIC_NATION_ID: item[0].SPECIFIC_NATION_ID,
            BRANCH_NAME_TH: item[0].BRANCH_NAME_TH,
            BRANCH_NAME_EN: item[0].BRANCH_NAME_EN,
            FACULTY_NAME_TH: item[0].FACULTY_NAME_TH,
            FACULTY_NAME_EN: item[0].FACULTY_NAME_EN,
            ROUND_NAME_TH: item[0].ROUND_NAME_TH,
            ROUND_NAME_EN: item[0].ROUND_NAME_EN,

            STUDY_ADMIT_TYPE_NAME_TH: item[0].STUDY_ADMIT_TYPE_NAME_TH,
            STUDY_ADMIT_TYPE_NAME_EN: item[0].STUDY_ADMIT_TYPE_NAME_EN,
            STUDY_PLAN_NAME_TH: item[0].STUDY_PLAN_NAME_TH,
            STUDY_PLAN_NAME_EN: item[0].STUDY_PLAN_NAME_EN,
            STUDY_CLASSES_NAME_TH: item[0].STUDY_CLASSES_NAME_TH,
            STUDY_CLASSES_NAME_EN: item[0].STUDY_CLASSES_NAME_EN,
            SPECIFIC_NATION_NAME_TH: item[0].SPECIFIC_NATION_NAME_TH,
            SPECIFIC_NATION_NAME_EN: item[0].SPECIFIC_NATION_NAME_EN,

            sum_static: item.reduce(
              (sum, curr) =>
                sum + (curr.count_static ? parseInt(curr.count_static) : 0),
              0
            ),
            sum_s1: item.reduce(
              (sum, curr) =>
                sum + (curr.count_s1 ? parseInt(curr.count_s1) : 0),
              0
            ),
            sum_s2: item.reduce(
              (sum, curr) =>
                sum + (curr.count_s2 ? parseInt(curr.count_s2) : 0),
              0
            ),
            sum_s3: item.reduce(
              (sum, curr) =>
                sum + (curr.count_s3 ? parseInt(curr.count_s3) : 0),
              0
            ),
            sum_s4: item.reduce(
              (sum, curr) =>
                sum + (curr.count_s4 ? parseInt(curr.count_s4) : 0),
              0
            ),
            sum_s5: item.reduce(
              (sum, curr) =>
                sum + (curr.count_s5 ? parseInt(curr.count_s5) : 0),
              0
            ),
            sum_s6: item.reduce(
              (sum, curr) =>
                sum + (curr.count_s6 ? parseInt(curr.count_s6) : 0),
              0
            ),
            sum_passed: item.reduce(
              (sum, curr) =>
                sum +
                (curr.count_rtpo1 ? parseInt(curr.count_rtpo1) : 0) +
                (curr.count_rtpo2 ? parseInt(curr.count_rtpo2) : 0) +
                (curr.count_rtpo3 ? parseInt(curr.count_rtpo3) : 0),
              0
            ),
          };
        });
        ret.push(temp);
      }
      return ret;
    },

    filtered_curriculums(project_id) {
      const table = this.get_filter_curriculum_by_project(project_id);
      const sum_sum_static = table.reduce(
        (sum, item) =>
          sum +
          item.reduce((subsum, subitem) => subsum + subitem.sum_static, 0),
        0
      );
      const sum_sum_s1 = table.reduce(
        (sum, item) =>
          sum + item.reduce((subsum, subitem) => subsum + subitem.sum_s1, 0),
        0
      );
      const sum_sum_s2 = table.reduce(
        (sum, item) =>
          sum + item.reduce((subsum, subitem) => subsum + subitem.sum_s2, 0),
        0
      );
      const sum_sum_s3 = table.reduce(
        (sum, item) =>
          sum + item.reduce((subsum, subitem) => subsum + subitem.sum_s3, 0),
        0
      );
      const sum_sum_s4 = table.reduce(
        (sum, item) =>
          sum + item.reduce((subsum, subitem) => subsum + subitem.sum_s4, 0),
        0
      );
      const sum_sum_s5 = table.reduce(
        (sum, item) =>
          sum + item.reduce((subsum, subitem) => subsum + subitem.sum_s5, 0),
        0
      );
      const sum_sum_s6 = table.reduce(
        (sum, item) =>
          sum + item.reduce((subsum, subitem) => subsum + subitem.sum_s6, 0),
        0
      );
      const sum_sum_passed = table.reduce(
        (sum, item) =>
          sum +
          item.reduce((subsum, subitem) => subsum + subitem.sum_passed, 0),
        0
      );

      const YEAR = table[0][0].YEAR;
      const SEMESTER = table[0][0].SEMESTER;

      const project_name_th =
        table.length > 0 ? table[0][0].PROJECT_NAME_TH : "ไม่มีข้อมูลหลักสูตร";
      const project_name_en =
        table.length > 0 ? table[0][0].PROJECT_NAME_EN : "ไม่มีข้อมูลหลักสูตร";
      const faculty_name_th =
        table.length > 0 ? table[0][0].FACULTY_NAME_TH : "ไม่มีข้อมูลคณะ";
      const faculty_name_en =
        table.length > 0 ? table[0][0].FACULTY_NAME_EN : "ไม่มีข้อมูลคณะ";

      const round_name_th =
        table.length > 0 ? table[0][0].ROUND_NAME_TH : "ไม่มีข้อมูลรอบ";
      const round_name_en =
        table.length > 0 ? table[0][0].ROUND_NAME_EN : "ไม่มีข้อมูลรอบ";

      const STUDY_ADMIT_TYPE_NAME_TH =
        table.length > 0
          ? table[0][0].STUDY_ADMIT_TYPE_NAME_TH
          : "ไม่มีข้อมูลประเภทรับเข้า";
      const STUDY_ADMIT_TYPE_NAME_EN =
        table.length > 0
          ? table[0][0].STUDY_ADMIT_TYPE_NAME_EN
          : "ไม่มีข้อมูลประเภทรับเข้า";
      const STUDY_PLAN_NAME_TH =
        table.length > 0
          ? table[0][0].STUDY_PLAN_NAME_TH
          : "ไม่มีข้อมูลแผนการศึกษา";
      const STUDY_PLAN_NAME_EN =
        table.length > 0
          ? table[0][0].STUDY_PLAN_NAME_EN
          : "ไม่มีข้อมูลแผนการศึกษา";
      const STUDY_CLASSES_NAME_TH =
        table.length > 0
          ? table[0][0].STUDY_CLASSES_NAME_TH
          : "ไม่มีข้อมูลวันเรียน";
      const STUDY_CLASSES_NAME_EN =
        table.length > 0
          ? table[0][0].STUDY_CLASSES_NAME_EN
          : "ไม่มีข้อมูลวันเรียน";
      const SPECIFIC_NATION_NAME_TH =
        table.length > 0
          ? table[0][0].SPECIFIC_NATION_NAME_TH
          : "ไม่มีข้อมูลประเภทนักศึกษารับเข้า";
      const SPECIFIC_NATION_NAME_EN =
        table.length > 0
          ? table[0][0].SPECIFIC_NATION_NAME_EN
          : "ไม่มีข้อมูลประเภทนักศึกษารับเข้า";

      const PROJECT_NAME_EN =
        project_id === "all" ? "All Project" : project_name_th;
      const PROJECT_NAME_TH =
        project_id === "all" ? "ทุกโครงการ" : project_name_en;

      return {
        YEAR,
        SEMESTER,
        PROJECT_NAME_EN,
        PROJECT_NAME_TH,
        project_id,
        table: table,
        sum_sum_static,
        sum_sum_s1,
        sum_sum_s2,
        sum_sum_s3,
        sum_sum_s4,
        sum_sum_s5,
        sum_sum_s6,
        sum_sum_passed,
        FACULTY_NAME_TH: faculty_name_th,
        FACULTY_NAME_EN: faculty_name_en,
        ROUND_NAME_TH: round_name_th,
        ROUND_NAME_EN: round_name_en,
        STUDY_ADMIT_TYPE_NAME_TH,
        STUDY_ADMIT_TYPE_NAME_EN,
        STUDY_PLAN_NAME_TH,
        STUDY_PLAN_NAME_EN,
        STUDY_CLASSES_NAME_TH,
        STUDY_CLASSES_NAME_EN,
        SPECIFIC_NATION_NAME_TH,
        SPECIFIC_NATION_NAME_EN,
      };
    },

    refresh() {
      this.select_year(this.year_id);
    },

    async select_year(year_id) {
      this.loading = true;
      if (this.passed_list_mode) {
        const data = await reportsService.getCurriculumOrderCountSummary(
          year_id
        );
        this.curriculums = data;
      } else {
        const data = await reportsService.getCurriculumCountSummary(year_id);
        this.curriculums = data;
      }
      this.loading = false;
    },
    groupBy(arr, key) {
      return arr.reduce((obj, item) => {
        var key_data = item[key];
        if (!Object.prototype.hasOwnProperty.call(obj, key_data)) {
          obj[key_data] = [];
        }
        obj[key_data].push(item);
        return obj;
      }, {});
    },
    async init_data() {
      this.loading = true;
      const faculties = await facultyService.getFaculties();
      this.registrar_faculties = faculties;

      // เจ้าหน้าที่คณะ-อาจารย์ จำกัดสิทธิ์การเข้าถึงข้อมูล
      if (!(['40', '45', '91'].includes(this.privilege))) {
        const executor_info = await configService.getExecutorInfo(this.user_id);

        this.registrar_faculties = this.registrar_faculties.filter((item) => {
          return executor_info.some(
            (ex) =>
              ex.FACULTY_ID === item.FACULTY_ID && ex.LEVEL_ID === this.level_id
          );
        });
      }

      if (this.level_id == "2" || this.level_id == "3") {
        const admit_types = await refService.getStudyAdmitTypes();
        this.admit_types = admit_types;
        const classes = await refService.getStudyClasses();
        this.classes = classes;
        const specific_nations = await refService.getSpecificNations();
        this.specific_nations = specific_nations;
        const programs = await refService.getStudyPlans();
        this.programs = programs.filter(
          (item) => item.LEVEL_ID === this.level_id
        );
      }

      this.loading = false;
    },
  },
  created: function () {
    this.init_data();
    this.$store.dispatch("ref/getLevels");
    this.$store.dispatch("officerConfig/getYears");
  },
};
</script>
